import React from "react"

export const Headline = ({ children, level }) => {
  const HeadlineLevel = `h${level}`
  return <HeadlineLevel>{children}</HeadlineLevel>
}
